export const DELIVERY_HAND_OPTIONS = [
  {
    value: 'meet_at_door',
    label: 'Meet at my door'
  }
  // TODO: Need to add it on the backend
  // {
  //   value: 'Meet Outside',
  //   label: 'Meet Outside'
  // },
  // {
  //   value: 'Meet In the Lobby',
  //   label: 'Meet In the Lobby'
  // }
];

export const DELIVERY_LEAVE_OPTIONS = [
  {
    value: 'leave_at_door',
    label: 'Leave at my door'
  }
  // {
  //   value: 'Leave at building reception',
  //   label: 'Leave at building reception'
  // }
];
